(function(variants) {
  'use strict';
  const dom = {};
  const cacheDom = () => {
    dom.variants = document.querySelectorAll('.variant');
    dom.variantTitleHolder = document.querySelector('.currentVariant');
  }
  const bindUIActions = () => {
    function selectVariant() {
      let subscriptionWrapper = document.getElementById('upscribe-subscription-product');
      let activeVariant = document.querySelector('.variant.is--active');
      let variantTitle = this.dataset.option;
      let variantPrice = this.dataset.price;
      activeVariant.classList.remove('is--active');
      this.classList.add('is--active');
      dom.variantTitleHolder.innerHTML = variantTitle;
      document.getElementById('product-price').innerHTML = variantPrice;

      if(typeof(subscriptionWrapper) != 'undefined' && subscriptionWrapper != null) {
        if (variantTitle.includes("Mini")) {
          subscriptionWrapper.style.display = "none";
          document.querySelector('.cu-productTypeSelect__itemOneTime label').click();
        } 
        else { 
          subscriptionWrapper.style.display = "block" 
        }
      }
    }
    dom.variants.forEach((variant) => {
      variant.addEventListener('click', selectVariant)
    })
  }
  const init = () => {
    cacheDom();
    bindUIActions();
  }
  variants.init = init;
})(window.variants = window.variants || {});

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  window.variants.init();
});
